import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { UserRole } from '../types/auth';
import { isDemoMode } from '../config/env';
import { mustVerifyContact } from '../lib/contactVerification';
import { t } from '../i18n';

export function ProtectedRoute({
  roles,
  allowUnverified,
}: {
  roles?: UserRole[];
  /** Allow access before email/phone verification (verify page only). */
  allowUnverified?: boolean;
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-screen__spinner" aria-label={t('loading')} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (
    !isDemoMode &&
    !allowUnverified &&
    mustVerifyContact(user) &&
    location.pathname !== '/verify-contact'
  ) {
    return <Navigate to="/verify-contact" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
